import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../Assets/home-main.svg";
import Particle from "../components/Common/Particle";
import Home2 from "../components/Home/Home2";
import Type from "../components/Home/Type";

function Home() {
    return (
        <section>
            <Container fluid className="home-section" id="home">
                <Particle />
                <Container className="home-content">
                    <Row>
                        <Col md={7} className="home-header">
                            <h1 className="home-header-heading">
                                Hello there!{" "}
                                <span
                                    className="wave"
                                    role="img"
                                    aria-label="waving hand"
                                >
                                    👋🏻
                                </span>
                            </h1>

                            <h1 className="heading-name">
                                I'm
                                <strong className="main-name">
                                    {" "}
                                    Mamadou Siradiou
                                </strong>
                            </h1>

                            <div className="type-container">
                                <Type />
                            </div>
                        </Col>

                        <Col md={5} style={{ paddingBottom: 20 }}>
                            <img
                                src={homeLogo}
                                alt="home pic"
                                className="img-fluid"
                                style={{ maxHeight: "450px" }}
                            />
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Home2 />
        </section>
    );
}

export default Home;
